import { getMonth, getDate } from "date-fns";
import './auto-generated-family-card.css'

const AutoGeneratedFamilyCard = ({family, name}) => {
    return (
        <div className="auto-generated-family-card">
            <div className="auto-generated-family-card__family-name">{name}</div>
            {family.map((event) => (
                <div className="auto-generated-family-card__each-lesson">
                    <div className="auto-generated-family-card__each-lesson__name">{event.studentName}</div>
                    <div className="auto-generated-family-card__each-lesson__date">{getMonth(new Date(event.dateTime))}/{getDate(new Date(event.dateTime))}</div>
                    <div className="auto-generated-family-card__each-lesson__length">{event.lessonLength} min</div>
                </div>
            ))}
        </div>
    )
}
export default AutoGeneratedFamilyCard;